import { useState } from 'react';
import { RotatableImage } from '../RotatableImage/RotatableImage';
import './photoitem.css';

interface PhotoItemProps {
  title: string;
  img: string | null;
  subClass: string;
  loading?: boolean;
  onRotate?: (direction: 'left' | 'right', imgUrl: string, photoType: string) => void;
  photoType?: string;
  isRotating?: boolean;
  rotation?: number;
  carId?: string;
}

function PhotoItem({ title = '', img, subClass, photoType = '', rotation = 0, carId = '' }: PhotoItemProps) {
  return (
    <div className="myphotoItemWrapper">
      <div className={` myphoto__item-img ${subClass ? subClass : ''}`}>
        <RotatableImage
          imageUrl={img}
          alt={title}
          photoType={photoType}
          entityId={carId}
          endpoint="/cars"
          initialRotation={rotation}
        />
      </div>
      <div className="myphotoItemTitle">{title}</div>
    </div>
  );
}

export default PhotoItem;
